import Seo from "@/components/Seo";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import Hero from "@/components/home/Hero";
import PainPoints from "@/components/home/PainPoints";
import Packages from "@/components/home/Packages";
import PlanQuiz from "@/components/home/PlanQuiz";
import HowItWorks from "@/components/home/HowItWorks";
import About from "@/components/home/About";
import Proof from "@/components/home/Proof";
import WhyClarus from "@/components/home/WhyClarus";
import Faq from "@/components/home/Faq";
import LeadMagnet from "@/components/home/LeadMagnet";
import QuoteForm from "@/components/site/QuoteForm";
import FinalCta from "@/components/home/FinalCta";

export default function HomePage() {
  return (
    <>
      <Seo
        title="Xero Bookkeeper for Trades & Startups | Clarus Partners"
        description="CPA-led Xero clean-ups, bookkeeping and fractional CFO support for trades businesses, startups and service businesses across Australia. Book a free consult."
      />
      <Header />
      <main>
        <Hero />
        <PainPoints />
        <Packages />
        <PlanQuiz />
        <HowItWorks />
        <About />
        <Proof />
        <WhyClarus />
        <Faq />
        <LeadMagnet />
        <QuoteForm />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
